export enum actionTypes {}
// SET_IMAGES ='SET_IMAGES'
export interface ActionType {
  type: "string";
  payload: any;
}

export enum MidserviceStatus {
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
}

export interface ModulesStatistics {
  chequesCount?: number;
  chequesDiscarded?: number;
  chequesSum?: number;
  skuCount?: number;
  inventoryCount?: number;
  eventsCount?: number;
}

export interface MidserviceType {
  id: number;
  online: MidserviceStatus;
  lastConnectionDatetime: string;
  deviceId: string;
  status: any;
  initInfo?: any;
  instanceType: string;
  address: string;
  name: string;
  version: string;
  domain: string;
  addressId: number;
  networkName: string;
  networkLogin: string;
  configHash?: string;
  configPatchHashes?: Record<number, string>;
}

export enum IssueStatus {
  OPENED = "Открыт",
  WORKING = "В работе",
  RESOLVED = "Решен",
  INCORRECT = "Ошибочный",
  DELETED = "Удален",
}

export enum SourceType {
  DEVICE = "Устройство",
  TRADEPOINT = "Торговая точка",
  NETWORK = "Сеть",
  USER = "Пользователь",
  REQUEST = "Запрос",
}

export interface IssueType {
  id: number;
  instanceId: string;
  domain: string;
  title: string;
  sourceId: string;
  sourceType: keyof typeof SourceType;
  addressId?: number;
  createdAt: Date;
  eventCount: number;
  status: keyof typeof IssueStatus;
  addressName?: string;
  networkName?: string;
}

export interface SingleIssueType extends IssueType {
  name: string;
  media: string;
  dueAt: Date;
  eventId: string;
}

export interface Participant {
  id: number;
  name: string;
  login: string;
  isAssignee: number;
}

export interface Attachment {
  type: string;
  uri: string;
}

export interface Media {
  text: string;
  attachments?: Attachment[];
}

export interface IComment {
  media: Media;
}

export interface UserComment extends IComment {
  userId: number;
  name: string | null;
  login: string;
  createdAt: Date;
}

export interface FullIssueType {
  singleIssue: SingleIssueType;
  comments: UserComment[];
  participants: Participant[];
}

export interface FileSharingType {
  filename: string;
  size: number;
  createdAt: string;
}

export interface InstanceLogsTabProps {
  logs?: InstanceLogsType[];
  apiLogs?: InstanceLogsType[];
}

export interface InstanceImagesTabProps {
  images?: ImagesType[];
}

export interface InstanceConfigType {
  id: number;
  workersMaxCount: number;
  backpressureDecay: number;
  queueMaxSize: number;
  dataDir: string;
  logRotateSize: string;
  logRotate: string;
  logStoreDays: number;
  logLevel: string;
  apiUrl: string;
  accessKey: string;
  updateAppcastUrl: string;
  updateCheckInterval: number;
  updateEnable: boolean;
  apiMode: string;
  monitorEnabled: boolean;
  heartBeatTimeout: number;
  statusReportPeriod: number;
  personalHost: string;
  personalPort: number;
  ssl: boolean;
  instance: number;
  modules: any[];
  diagnostics: any[];
}

export interface RestartRequestType {
  toHost: string;
}

export interface DeleteLogsType {
  toHost: string;
}

export interface InstanceLogsType {
  archiveUrl: string;
  name: string;
  created: string;
}

export interface ImagesType {
  imageUrl: string;
  name: string;
  created: number;
}

export interface MessageType {
  id?: number;
  instanceId: number;
  callId: string;
  requestMethod: string;
  requestParams: any;
  requestTime: number;
  response?: any;
  responseTime?: number;
  authorId?: number;
  authorLogin?: string;
  isCollapseOpen?: boolean;
}

export interface WebosocketMessageType {
  messageType:
    | "INSTANCE_STATUS"
    | "ONLINE_STATUS"
    | "COMMAND_RESULT"
    | "NOTIFICATION"
    | "ADD_IMAGE"
    | "ADD_LOGS"
    | "ADD_FILE"
    | "ISSUE_STATUS"
    | "ISSUE_PARTICIPANTS"
    | "ISSUE_COMMENTS"
    | "ISSUE_STATUS_TELEMETRY"
    | "ISSUE_REGISTER_TELEMETRY"
    | "ISSUES_UPDATE";
  message: any;
}

type NotificationType = "success" | "info" | "warning" | "error";

export interface Notification {
  message: string;
  description: string;
  notificationType: NotificationType;
}

export interface PaginationParams {
  page: number;
  limit: number;
  sort?: string | null;
  filter?: string | null;
  search?: string | null;
}

export interface PaginationResponse<T> {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecord: number;
  content: T;
}

export interface InstanceStatusSchema {
  id: number;
  version: string;
  version_midservice: string;
  hardware: string;
  os: string;
  modules: any[];
  service_path: string;
  hdd_free: number;
  hdd_total: number;
  stats_cpu_load: number;
  stats_hdd_load: number;
  time: string;
}

export interface ObdInfoType {
  deviceId: number;
  deviceName: string;
  deviceType: number;
  status: number;
  addressType: number;
  addressId: number;
  addressCity: string;
  addressTimezone: number;
  addressName: string;
  addressStreet: string;
  addressHouse: string;
  addressExtId: number;
  networkId: number;
  networkName: string;
  networkExId: number;
  networkStatus: number;
}

export interface FullInstanceType {
  midserviceInstance: MidserviceType;
  config: InstanceConfigType;
  logs: InstanceLogsType[];
  apiLogs: InstanceLogsType[];
  images: ImagesType[];
  messages: MessageType[];
  methods: string[];
  obdInfo?: ObdInfoType;
}

export interface RequestLogsType {
  deviceId: string;
  domain: string;
  days: number;
}

export interface SendConfigType {
  deviceId: string;
  domain: string;
  config: InstanceConfigType;
}

export interface SendCommandParamsType {
  deviceId: string;
  domain: string;
  message: MessageType;
}

export interface SendCommandToDeviceListType {
  devices?: Record<string, Record<string, string>>;
  message: MessageType;
  search?: string;
}
